import TourTitle from './TourTitle'

export default TourTitle
